module.exports = __webpack_public_path__ + "img/2.c23d4189.jpg";